var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnevlope(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.766,
    height: 14.88,
    viewBox: "0 0 14.766 14.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "at-sign_3_",
    "data-name": "at-sign (3)",
    transform: "translate(0.679 0.574)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3193",
    "data-name": "Ellipse 3193",
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(4.076 4.076)",
    fill: "none",
    stroke: "#1b2430",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28801",
    "data-name": "Path 28801",
    d: "M11.51,6.076v3.4a2.038,2.038,0,1,0,4.076,0V8.793a6.793,6.793,0,1,0-2.663,5.394",
    transform: "translate(-1.999 -2)",
    fill: "none",
    stroke: "#1b2430",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnevlope);
export default __webpack_public_path__ + "static/media/enevlope.b1be8123245b7d36d91696af01224337.svg";
export { ForwardRef as ReactComponent };